export const ENDPOINTS = {
  billboards: "/api/v1/billboards",
  billboardsList: "/api/v2/billboards",
  billboardStreams: "/api/v1/billboards/streams",
  billboardById: (id: number) => `/api/v1/billboards/${id}`,

  copyBillboard: (id: number) => `/api/v1/billboards/${id}/copy`,
  pinBillboard: (id: number) => `/api/v1/billboards/${id}/pin`,

  templatesList: "/api/v1/billboards/templates/short",
  billboardOffersList: "/api/v1/billboards/offers/billboards/short",
  billboardStreamsList: "/api/v1/billboards/streams/billboards/short",
  billboardUsersList: "/api/v1/billboards/users/billboards/short",
  usersList: "/api/v1/billboards/users/short",
  streamOffersList: "/api/v1/billboards/streams/offers/short",
  streamOffers: "/api/v1/billboards/offers/short",

  streamHosts: "/api/v1/billboards/hosts/short",
  streamDomains: "/api/v1/billboards/domains/short",

  settings: "/api/v1/billboards/settings",
  getFullUser: "/api/v2/User/GetFullUser",

  uploadImage: "/api/v2/image/Upload",
  getImage: (image: string) => `/image/${image}`,
  logos: "/api/v1/static/logos",
  favicons: "/api/v1/static/favicons",
  newsImages: "/api/v1/static/images",
  bgImages: "/api/v1/static/background-images",
  getLogoById: (id: string) => `/logos/${id}`,
  getFaviconById: (id: string) => `/favicons/${id}`,
  getNewsImageById: (id: string) => `/images/${id}`,
  getBgImageById: (id: string) => `/background-images/${id}`,

  linksList: (id: number) => `/api/v1/billboards/${id}/streams`,

  monitoringReportList: "/api/v2/monitoring/reports",
  monitoringReportById: (id: number) => `/api/v1/monitoring/reports/${id}`,
  monitoringReportManifestsById: (id: number) => `/api/v1/monitoring/manifests/${id}`,
  monitoringGlobalSettings: "/api/v1/monitoring/settings",
  monitoringSettingsById: (id: number) => `/api/v1/monitoring/settings/${id}`,

  monitoringAuditById: (id: number) => `/api/v1/billboards/audit/${id}`,
  monitoringAuditDiffById: (id: number, version: number) =>
    `/api/v1/billboards/audit/${id}/${version}`,

  mattermostChannelsList: "/api/v1/mattermost/channels",
  telegramChannelsList: "/api/v1/telegram/channels",

  statistic: (id: number) => `/api/v1/statistics/billboards/${id}/streams/short`,
  statisticBillboards: "/api/v1/statistics/billboards/short",

  extraData: "/api/v1/billboards/extra_data",

  customLogicTags: "/api/v1/billboards/custom-logic-tags",
};
